"use strict";

import angular from "angular";

class RegisteredCompanyDialogCtrl {
    constructor($mdDialog, locals, DSNDialogService, $state) {
        this.$mdDialog = $mdDialog;
        this.locals = locals;
        this.DSNDialogService = DSNDialogService;
        this.$state = $state;
    }

    $onInit() {}

    onAddNewCompany() {
        this.$state.go("nucont.accounting.journey.import.cadsim");

        this.$mdDialog.hide();
    }
}
angular.module("nucont.shared").controller("RegisteredCompanyDialogCtrl", [
        "$mdDialog",
        "locals",
        "DSNDialogService",
        "$state",
        RegisteredCompanyDialogCtrl
    ]);
